<template>
  <section class="passe-livre">
    <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">
          {{
            currentRouter === "ceara-app-passe-livre-cadastro"
              ? "Cadastro"
              : "Editar"
          }}
          - Passe Livre Intermunicipal
        </v-card-title>
        <v-card-text class="app-card-content">
          <ul class="breadcrumbs-register">
            <li
              class="breadcrumbs-register__item breadcrumbs-register__item--active"
            >
              1 - Beneficiário
            </li>
            <li class="breadcrumbs-register__item">2 - Confirmar</li>
          </ul>
          <v-row>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <input
                type="hidden"
                v-model="form.id"
                v-if="currentRouter === 'ceara-app-passe-livre-edit-cadastro'"
              />
              <v-text-field
                v-model="form.cpf"
                placeholder="Digite seu cpf"
                label="CPF *"
                v-mask="'###.###.###-##'"
                :rules="[rules.required, rules.cpf]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.nome"
                placeholder="Digite seu nome"
                label="Nome Completo *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="8" :sm="8" :xs="12" cols="12">
              <v-text-field
                v-model="form.dataNascimento"
                placeholder="Ex.: 17/04/1976"
                label="Data Nascimento *"
                v-mask="'##/##/####'"
                :rules="[rules.required, rules.birth]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12">
              <label>Sexo *</label>
              <v-radio-group
                v-model="form.sexo"
                :rules="[rules.required]"
                row
                class="mt-0"
              >
                <v-radio
                  v-for="s in sexo"
                  :key="s.key"
                  :label="s.value"
                  :value="s.key"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-text-field
                v-model="form.numeroDocumento"
                placeholder="Digite o número do documento"
                label="Documento *"
                v-mask="'#####################'"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-text-field
                v-model="form.dataEmissaoDocumento"
                placeholder="Ex.: 18/04/1996"
                :rules="[rules.required]"
                v-mask="'##/##/####'"
                label="Emissão Documento *"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-text-field
                v-model="form.orgaoEmissorDocumento"
                placeholder="Ex.: SSPDS"
                label="Órgão Emissor *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="12" cols="12">
              <v-autocomplete
                v-model="form.ufDocumento"
                :loading="loadingEstado"
                :items="estados"
                :search-input.sync="searchEstados"
                :item-text="'nome'"
                :item-value="'nome'"
                :rules="[rules.required]"
                cache-items
                hide-no-data
                hide-details
                label="Uf Documento*"
                placeholder="Selecione um Estado"
                filled
                rounded
                dense
              ></v-autocomplete>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-row>
                <v-col :md="2" :sm="2" :xs="12" cols="12" class="pt-0">
                  <div class="form-control mb-5">
                    <label for="ddd">DDD *</label>
                    <InputMask
                      id="ddd"
                      v-model="form.dddTelefone"
                      placeholder="Ex.: 85"
                      maskT="##"
                      :masked="true"
                    />
                  </div>
                </v-col>
                <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0">
                  <div class="form-control mb-5">
                    <label for="telefone">Telefone *</label>
                    <InputMask
                      id="telefone"
                      v-model="form.telefone"
                      placeholder="Ex.: 98755-9988"
                      maskT="#####-####"
                      :masked="true"
                    />
                  </div>
                </v-col>
                <v-col :md="2" :sm="2" :xs="12" cols="12" class="pt-0">
                  <div class="form-control mb-5">
                    <label for="ddd2">DDD 2</label>
                    <InputMask
                      id="ddd2"
                      v-model="form.telefones[0].ddd"
                      placeholder="Ex.: 85"
                      maskT="##"
                    />
                  </div>
                </v-col>
                <v-col :md="4" :sm="4" :xs="12" cols="12" class="pt-0">
                  <div class="form-control mb-5">
                    <label for="telefone2">Telefone 2</label>
                    <InputMask
                      id="telefone2"
                      v-model="form.telefones[0].telefone"
                      placeholder="Ex.: 98755-9988"
                      maskT="#####-####"
                      :masked="true"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.nomeMae"
                placeholder="Ex.: Digite o nome da Mãe"
                label="Nome da Mãe *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <label>Necessita de Acompanhamente? *</label>
              <v-radio-group
                v-model="form.acompanhante"
                :rules="[rules.required]"
                row
                class="mt-0"
              >
                <v-radio :key="3" :label="`Sim`" :value="'true'"></v-radio>
                <v-radio :key="4" :label="`Não`" :value="'false'"></v-radio>
              </v-radio-group>
            </v-col>
            <p class="red--text mb-0 ml-5">
              *Caso ocorra a necessidade do acompanhante, deverá constar no
              laudo médido a informação sobre o mesmo.
            </p>
          </v-row>
          <div class="loading" v-if="isLoading">
            <v-progress-circular
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>

      <v-card outlined class="app-card">
        <v-card-title class="app-card-title">Endereço</v-card-title>
        <v-card-text class="app-card-content">
          <v-row>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                v-model="form.cep"
                placeholder="Digite seu cep"
                label="Cep*"
                v-mask="'#####-###'"
                filled
                rounded
                dense
                masked="false"
                @input="searchCep"
                :loading="isLoadingCep"
                :rules="[rules.required, rules.cep]"
              >
                <template v-slot:progress>
                  <v-progress-circular
                    v-if="isLoadingCep"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </template>
              </v-text-field>
            </v-col>
            <v-col :md="9" :sm="9" :xs="9" cols="12">
              <v-text-field
                v-model="form.logradouro"
                placeholder="Ex.: Rua das Acácias"
                label="Logradouro *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="3" :sm="3" :xs="3" cols="12">
              <v-text-field
                v-model="form.numeroLogradouro"
                placeholder="Número Logradouro"
                label="Número *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="6" cols="12">
              <v-text-field
                v-model="form.bairro"
                placeholder="Bairro"
                label="Bairro *"
                :rules="[rules.required]"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="6" :sm="6" :xs="6" cols="12">
              <v-autocomplete
                v-model="form.municipio.id"
                :loading="loadingMunicipio"
                :items="municipios"
                :search-input.sync="searchMunicipios"
                :item-text="'nome'"
                :item-value="'id'"
                :rules="[rules.required]"
                cache-items
                hide-no-data
                hide-details
                label="Município*"
                placeholder="Selecione um Município"
                filled
                rounded
                dense
              ></v-autocomplete>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :loadRecaptchaScript="true"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
              ></vue-recaptcha>
              <v-input
                v-model="form.recaptcha"
                :rules="[rules.required]"
              ></v-input>
            </v-col>
          </v-row>
          <div class="loading" v-if="isLoading">
            <v-progress-circular
              :size="25"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>

      <v-row>
        <v-col :md="2">
          <v-btn
            outlined
            block
            large
            color="primary"
            type="button"
            @click="backToLogin()"
            >Cancelar</v-btn
          >
        </v-col>
        <v-col :md="2" :offset-md="8">
          <v-btn depressed block large color="primary" type="submit"
            >Continuar</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import BeneficiarioService from "@/services/beneficiario.service";
import BeneficiarioAuthService from "@/services/beneficiarioCearaApp.auth.service";
import EstadoService from "@/services/estado.service";
import MunicipioService from "@/services/municipio.service";
import BeneficiarioStore from "@/store/modules/beneficiario";
import { validateCpf } from "@/helpers/cpf.validator";
import { Subject, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  map,
  switchMap,
  delay
} from "rxjs/operators";
import CepService from "@/services/cep.service";
import moment from "moment";

import InputMask from "@/components/form/InputMask";
import { maskT } from "@/directives/mask";

import { checkDate } from "@/util/validate";

export default {
  name: "CadastroForm",
  components: {
    VueRecaptcha,
    InputMask
  },
  directives: {
    mask,
    maskT
  },
  data() {
    return {
      currentRouter: null,
      isLoadingCep: false,
      patternCep: /^[0-9]{2}[0-9]{3}-[0-9]{3}$/,
      subjectCep: null,
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      estados: [],
      loadingEstado: false,
      searchEstados: null,
      itemsEstados: [],
      municipios: [],
      loadingMunicipio: false,
      searchMunicipios: null,
      itemsMunicipios: [],
      sexo: [
        { key: 1, value: "Masculino" },
        { key: 2, value: "Feminino" }
      ],
      form: {
        id: null,
        cpf: null,
        nome: null,
        dataNascimento: null,
        sexo: null,
        numeroDocumento: null,
        dataEmissaoDocumento: null,
        orgaoEmissorDocumento: null,
        ufDocumento: null,
        dddTelefone: null,
        telefone: null,
        nomeMae: null,
        acompanhante: null,
        cep: null,
        logradouro: null,
        numeroLogradouro: null,
        bairro: null,
        recaptcha: null,
        municipio: {
          id: null,
          estado: {
            id: 1
          }
        },
        telefones: [{ id: null, ddd: "", telefone: "" }]
      },
      beneficiario: null,
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        cpf: value => !!validateCpf(value) || "CPF inválido",
        cep: value => {
          const pattern = this.patternCep;
          return pattern.test(value) || "Cep inválido.";
        },
        birth: value => !!checkDate(value) || "Data de Nascimento inválida"
      }
    };
  },
  mounted() {
    this.getCurrentRouter();
    this.loadBeneficiario();
    this.cepSubject();
    this.loadEstados();
    this.loadMunicipios();
    this.loadCpfNascimento();
    this.toTop();
  },
  methods: {
    toTop() {
      this.$vuetify.goTo(0);
    },
    loadBeneficiario() {
      if (this.currentRouter === "ceara-app-passe-livre-edit-cadastro") {
        const beneficiario = BeneficiarioAuthService.currentBeneficiarioValue();
        this.isLoading = true;
        BeneficiarioService.findByCpfNascimento(
          beneficiario.cpf,
          beneficiario.dataNascimento
        ).subscribe(res => {
          this.beneficiario = res;
          this.setForm();
        });
      }
    },
    setForm() {
      if (
        this.currentRouter === "ceara-app-passe-livre-edit-cadastro" &&
        this.beneficiario
      ) {
        this.form.id = this.beneficiario.id;
        this.form.cpf = this.beneficiario.cpf;
        this.form.dataNascimento = moment(
          this.beneficiario.dataNascimento,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
        this.form.nome = this.beneficiario.nome;
        this.form.sexo = Number(this.beneficiario.sexo);
        this.form.numeroDocumento = this.beneficiario.numeroDocumento;
        this.form.ufDocumento = this.beneficiario.ufDocumento;
        this.form.orgaoEmissorDocumento = this.beneficiario.orgaoEmissorDocumento;
        this.form.dataEmissaoDocumento = moment(
          this.beneficiario.dataEmissaoDocumento,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
        this.form.dddTelefone = this.beneficiario.dddTelefone;
        this.form.telefone = this.beneficiario.telefone;
        this.form.nomeMae = this.beneficiario.nomeMae;
        this.form.acompanhante = String(this.beneficiario.acompanhante);

        this.form.cep = this.beneficiario.cep;
        this.form.logradouro = this.beneficiario.logradouro;
        this.form.numeroLogradouro = this.beneficiario.numeroLogradouro;
        this.form.bairro = this.beneficiario.bairro;
        this.form.municipio.id = this.beneficiario.municipio.id;

        if (this.beneficiario.telefones && this.beneficiario.telefones.length) {
          this.form.telefones = this.beneficiario.telefones;
        }

        this.isLoading = false;
      }
    },
    getCurrentRouter() {
      this.currentRouter = this.$route.name;
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        if (this.currentRouter === "ceara-app-passe-livre-edit-cadastro") {
          const { processo } = this.$route.params;
          BeneficiarioService.update(processo, this.form).subscribe(
            response => {
              BeneficiarioAuthService.setSessionFromRegister(response);
              this.isLoading = false;
            },
            error => {
              this.isLoading = false;
            }
          );
        } else {
          BeneficiarioService.create(this.form).subscribe(
            res => {
              BeneficiarioAuthService.setSessionFromRegister(res);
              this.isLoading = false;
              this.$refs.form.reset();
              this.$refs.recaptcha.reset();
              this.$vuetify.goTo(100);
            },
            error => {
              this.isLoading = false;
              //throwError(error);
            }
          );
        }
      } else {
        this.expiredRecaptcha();
      }
    },
    loadCpfNascimento() {
      const data = BeneficiarioAuthService.currentCpfNascimentoValue();
      if (data) {
        this.form.cpf = data.cpf;
        this.form.dataNascimento = data.nascimento;
      }
    },
    backToLogin() {
      if (this.$route.name === "ceara-app-passe-livre-edit-cadastro") {
        this.$router.push({
          name: "ceara-app-passe-livre-detalhe",
          params: { id: this.beneficiario.id }
        });
      } else {
        this.$router.push({ name: "ceara-app-passe-livre" });
      }
    },
    loadEstados() {
      EstadoService.getAll().subscribe(
        response => {
          this.estados = response;
        },
        error => {}
      );
    },
    loadMunicipios() {
      MunicipioService.getAll().subscribe(
        response => {
          this.municipios = response;
        },
        error => {}
      );
    },
    searchCep(value) {
      this.subjectCep.next(value);
    },
    cepSubject() {
      this.subjectCep = new Subject();
      this.subjectCep
        .pipe(debounceTime(500))
        .pipe(distinctUntilChanged())
        .pipe(tap(value => (this.isLoadingCep = true)))
        .pipe(
          switchMap(value => {
            const pattern = this.patternCep;
            const validCep = pattern.test(value);
            if (!validCep) {
              return of({ error: "Cep invalido" });
            }
            return CepService.find(value);
          })
        )
        .pipe(delay(500))
        .subscribe(
          res => {
            this.isLoadingCep = false;
            if (!res.error) {
              const { logradouro, uf, localidade, bairro } = res.data;

              if (logradouro) {
                this.form.logradouro = logradouro;
              }

              if (bairro) {
                this.form.bairro = bairro;
              }

              if (localidade) {
                const municipio = this.municipios.filter(
                  mu => mu.nome === localidade.toUpperCase()
                );

                this.form.municipio.id = municipio[0].id;
              }
            }
          },
          error => {
            this.isLoadingCep = false;
          }
        );
    },
    querySelectionsEstados(v) {
      this.loadingEstado = true;
      this.itemsEstados = this.estados.filter(e => {
        return (
          (e.nome || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
        );
      });
      this.loadingEstado = false;
    },
    querySelectionsMunicipios(v) {
      this.loadingMunicipio = true;
      this.itemsMunicipios = this.municipios.filter(e => {
        return (
          (e.nome || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
        );
      });
      this.loadingMunicipio = false;
    }
  },
  watch: {
    searchEstados(val) {
      val && val !== this.form.ufDocumento && this.querySelectionsEstados(val);
    },
    searchMunicipios(val) {
      val &&
        val !== this.form.municipio.id &&
        this.querySelectionsMunicipios(val);
    }
  }
};
</script>

<style scoped lang="scss">
.breadcrumbs-register {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  //border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 0px;
  margin-bottom: 25px;

  &__item {
    padding: 10px;
    list-style: none;
    background-color: #ededed;
    display: flex;
    flex: 1;
    text-transform: uppercase;
    text-align: center;
    font-size: 17px;
    justify-content: center;
    color: #2e70b6;
    position: relative;
    padding-left: 30px;
    &:last-child {
      margin-right: 13px;
    }
    &:after {
      position: absolute;
      display: block;
      border: 21px solid transparent;
      border-left: 16px solid #ededed;
      border-right: 0;
      top: 0px;
      z-index: 10;
      content: "";
      right: -15px;
    }
    &--active {
      background-color: #2e70b6;
      color: #fff;
      &:after {
        border-left-color: #2e70b6;
      }
    }
  }
}
.v-progress-circular {
  height: 22px !important;
  width: 22px !important;
  top: 16px !important;
}
.alert {
  &-title {
    margin: 0px 0px 5px;
    font-weight: 500 !important;
    font-size: 17px !important;
  }
  &-list {
    &__item {
      margin-bottom: 5px;
    }
  }
}
</style>
